export default __webpack_public_path__ + "static/media/IR.7938c13d.svg";